<template>
    <b-modal
        ref="modalConfirm"
        lazy
        title-tag="h2"
        title="Confirm Supplier"
        ok-title="Proceed"
        footer-class="d-flex justify-content-between"
    >
        <p>
            Are you sure you want to change the supplier? Items that have been
            added will be removed. This action cannot be undone.
        </p>

        <template v-slot:modal-footer="{ close }">
            <b-button class="mr-auto" variant="secondary" @click="close">
                Cancel
            </b-button>

            <b-button variant="primary" @click="proceed">
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>

<script type="text/javascript">
export default {
    methods: {
        open() {
            this.$refs.modalConfirm.show();
        },
        proceed() {
            this.$refs.modalConfirm.hide();
            this.$emit("proceed");
        }
    }
};
</script>
